module.exports = __webpack_public_path__ + "img/1.1c2504b8.png";